import { shouldAddItem } from '../shouldAddItem';
import { fileCollectionItemUngzip } from './fileCollectionItemUngzip';
import { fileCollectionItemUnzip } from './fileCollectionItemUnzip';
/**
 * Utility function that allows to expand gzip and zip files without really expanding them
 * @param fileCollection
 * @param options
 * @returns
 */
export async function expandAndFilter(fileCollectionItem, options = {}) {
    const { filter = {} } = options;
    if (!shouldAddItem(fileCollectionItem.relativePath, filter)) {
        return [];
    }
    fileCollectionItem = await fileCollectionItemUngzip(fileCollectionItem, options);
    const fileCollectionItems = fileCollectionItemUnzip(fileCollectionItem, options);
    return fileCollectionItems;
}
//# sourceMappingURL=expandAndFilter.js.map